import { createContext, useContext } from 'react';

export interface LocalPermissionOverrideContextValue {
  permissions: string[] | null;
  setPermissions: (permissions: string[]) => void;
  clear: () => void;
}

export const LocalPermissionOverrideContext = createContext<LocalPermissionOverrideContextValue | null>(null);

export const useLocalPermissionOverride = (): string[] | undefined =>
  useContext(LocalPermissionOverrideContext)?.permissions ?? undefined;

export const useLocalPermissionOverrideControls = () => {
  const context = useContext(LocalPermissionOverrideContext);
  if (!context) {
    throw new Error('useLocalPermissionOverrideControls must be used within LocalPermissionOverrideProvider');
  }
  return { setPermissions: context.setPermissions, clear: context.clear };
};
